/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_OfflineInputs */

const en_dropbox_offline = /** @type {(inputs: Dropbox_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to use Dropbox.`)
};

const es_dropbox_offline = /** @type {(inputs: Dropbox_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctate a internet para usar Dropbox.`)
};

/**
* | output |
* | --- |
* | "Connect to the internet to use Dropbox." |
*
* @param {Dropbox_OfflineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_offline = /** @type {((inputs?: Dropbox_OfflineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_OfflineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_offline(inputs)
	return en_dropbox_offline(inputs)
});